import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  GenericObjectInterface,
  headersList,
  makeApiRequest,
} from "@/src/utilities";
import { API_ENDPOINTS } from "@/src/utilities";
import { ImageLoader } from "../ImageLoader";
import { renderStars } from "../RenderStar";
import { PaginationButtons } from "../PaginationButtons";
import { ITEMS_PER_PAGE } from "@/src/utilities/constants/constants";
import { useAppSelector } from "@/src/store/hooks";
import Image from "next/image";

interface PaginationMeta {
  pagination: {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
  };
}

interface ProductsResponse {
  data: GenericObjectInterface[];
  meta: PaginationMeta;
}

async function fetchProducts(page: number, selectedSubcategories: string) {
  const res = await makeApiRequest(
    "GET",
    `${API_ENDPOINTS.GET_PRODUCTS_BY_CATEGORY}/${selectedSubcategories}?pagination[page]=${page}&pagination[pageSize]=${ITEMS_PER_PAGE}`,
    null,
    headersList
  );
  return res?.data;
}

function ComparisonModalContent({
  selectedSubcategories,
  handleCompare,
}: {
  selectedSubcategories: string;
  handleCompare: (id: GenericObjectInterface) => void;
}) {
  const [page, setPage] = useState(1);

  const {
    data: productList,
    isLoading,
    isError,
  } = useQuery<any>({
    queryKey: ["products-modal", selectedSubcategories, page],
    queryFn: () => fetchProducts(page, selectedSubcategories),
  });

  const {
    comparedProducts,
  } = useAppSelector((root) => root.unGatedContentStateReducer);

  const totalPages = productList?.meta?.pagination?.pageCount || 1;

  return (
    <div className="overflow-y-auto p-4 rounded-lg">
      {isLoading && <p className="text-center">Loading...</p>}
      {isError && (
        <p className="text-center text-red-500">Error fetching products</p>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {productList?.data?.map((product: GenericObjectInterface) => (
          <div
            key={product?.documentId}
            className={`hover:scale-105 transition-all cursor-pointer h-32 md:min-w-24 flex flex-col items-center p-2 border rounded-lg shadow-sm border-green-400 ${comparedProducts?.selectedForComparison?.find((el: GenericObjectInterface) => el?.documentId == product?.documentId) ? "border-2" : "border-none"}`}
            onClick={() => handleCompare(product)}
          >
            <div className="h-20 w-full flex items-center justify-center flex-shrink-0">
              <Image
                src={product?.product_logo_url}
                alt={product?.name || "Product logo"}
                width={70}
                height={70}
                className="object-contain max-h-full"
              />
            </div>
            <p className="px-2 py-1 text-xs font-semibold w-full rounded-md truncate text-center mt-auto">
              {product?.name}
            </p>
            {/* <div className="mt-2">{renderStars(product?.average_stars)}</div> */}
          </div>
        ))}
      </div>

      <PaginationButtons
        currentPage={page}
        totalPages={totalPages}
        onPageChange={setPage}
      />
    </div>
  );
}

export default ComparisonModalContent;
